<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 4</div>
    <h1 class="theme-heading__title">Важность профилактики</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Комплексный подход</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-4/cat-1.webp" type="image/webp">
          <img src="/static/img/theme-4/cat-1.jpg" alt="Комплексный подход"/>
        </picture>
      </div>
      <p class="theme-point__text"><span class="accent">Продуманный выбор корма, вакцинация, обработки против паразитов, регулярная гигиена и&nbsp;консультации с&nbsp;профильными специалистами </span>&mdash; обязательные составляющие ухода за&nbsp;питомцем, помогающие поддерживать его активность и&nbsp;здоровье на&nbsp;протяжении всей жизни.</p>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">Вакцинация</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-4/cat-2.webp" type="image/webp">
          <img src="/static/img/theme-4/cat-2.png" alt="Вакцинация"/>
        </picture>
      </div>
      <p class="theme-point__text"><span class="accent">Вакцинация&nbsp;</span>&mdash;&nbsp;основной метод предупреждения инфекционных заболеваний. Она позволит защитить не&nbsp;только само животное, но&nbsp;и&nbsp;вашу семью. Прививки делятся на&nbsp;обязательные и&nbsp;факультативные.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Обычно <span class="accent">первые вакцины вводятся котенку в&nbsp;возрасте 6&ndash;8&nbsp;недель. В&nbsp;12-16 недель процедура повторяется.</span> Вашему котенку потребуется <span class="accent">регулярная вакцинация&nbsp;&mdash; через год после второй инъекции и&nbsp;ежегодно после этого.</span></p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Обработки против гельминтов</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-4/cat-3.webp" type="image/webp">
          <img src="/static/img/theme-4/cat-3.png" alt="Обработки против гельминтов"/>
        </picture>
      </div>
      <p class="theme-point__text">Рекомендуется <span class="accent">регулярно проводить животным обработки против гельминтов</span>. Котятам внутренние паразиты наносят особенно серьезный вред, поэтому дегельминтизацию придется проводить регулярно. Гельминты могут представлять <span class="accent">опасность и&nbsp;для людей</span> (в&nbsp;первую очередь для детей)&nbsp;&mdash; при контакте с&nbsp;животными.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Поэтому очень важно обсудить <span class="accent">план противопаразитарных обработок</span>, антигельминтных обработок и&nbsp;т.д.&nbsp;с&nbsp;ветеринарным врачом. Он&nbsp;порекомендует решение, учитывающее риск, характерный для местности, где содержится животное, и&nbsp;для его образа жизни.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">УХОД ЗА&nbsp;ЗУБАМИ</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-4/cat-4.webp" type="image/webp">
          <img src="/static/img/theme-4/cat-4.png" alt="УХОД ЗА&amp;nbsp;ЗУБАМИ"/>
        </picture>
      </div>
      <p class="theme-point__text">Основная профилактическая мера&nbsp;— <span class="accent">ежедневная чистка зубов</span> кошек специальной щеткой и&nbsp;пастой. Сухой корм также замедляет образование зубного камня.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">У&nbsp;кошек заболевания зубов совсем не&nbsp;редкость. Они почти не&nbsp;болеют кариесом, но&nbsp;страдают от&nbsp;воспаления десен и&nbsp;зубного камня. Эти проблемы доставляют кошке дискомфорт и&nbsp;могут привести к&nbsp;потере зубов.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">5</span>
      <h2 class="theme-point__title">Вычесывание и&nbsp;купание</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-4/cat-5.webp" type="image/webp">
          <img src="/static/img/theme-4/cat-5.jpg" alt="Вычесывание и&amp;nbsp;купание"/>
        </picture>
      </div>
      <p class="theme-point__text"><span class="accent">Регулярное вычесывание и&nbsp;купание</span> позволят поддержать красоту шерсти и&nbsp;сохранить здоровье кожи. У&nbsp;длинношерстных животных шерсть довольно быстро спутывается, что может привести к&nbsp;заболеваниям кожи, дискомфорту и&nbsp;болевым ощущениям.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Короткошерстных кошек нужно <span class="accent">расчесывать 1-2 раза в&nbsp;неделю</span>, мыть&nbsp;&mdash; по&nbsp;мере необходимости. <span class="accent">Длинношерстных кошек</span> необходимо расчесывать ежедневно. <span class="accent">Бесшерстных кошек</span> тоже расчесывают мягкой щеткой из&nbsp;натуральной щетины для массажа кожи.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">6</span>
      <h2 class="theme-point__title">Кастрация и&nbsp;стерилизация</h2>
      <p class="theme-point__text">У&nbsp;кастрированных кошек <span class="accent">снижается риск возникновения некоторых серьезных заболеваний</span>. Если в&nbsp;будущем вы&nbsp;не&nbsp;планируете получать потомство от&nbsp;своего питомца, то&nbsp;лучше его кастрировать. Это простая операция, которая позволит предотвратить развитие некоторых заболеваний и&nbsp;сохранит игривый нрав и&nbsp;дружелюбие котенка.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Важно знать, что после кастрации животные обычно начинают больше есть, тогда как их&nbsp;потребности в&nbsp;энергии, напротив, снижаются. Чтобы предотвратить развитие ожирения, нужно подобрать низкокалорийный корм.</p>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для котят</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-1-1.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-1-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-1-2.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-1-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-1-3.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-1-3.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-1-4.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-1-4.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для взрослых кошек</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-2-1.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-2-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-2-2.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-2-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-2-3.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-2-3.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-4/cat-slider-2-4.webp" type="image/webp">
                <img src="/static/img/theme-4/cat-slider-2-4.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point-tabs">
        <button class="theme-point-tabs__btn" data-tab-button="kitten" data-tab-button-state="active" @click="sendEventYM('diet_step4_click_btn', {'diet_step4_click_btn_param': 'Для котят'})">Для котят</button>
        <button class="theme-point-tabs__btn" data-tab-button="cat" @click="sendEventYM('diet_step4_click_btn', {'diet_step4_click_btn_param': 'Для взрослых кошек'})">Для взрослых кошек</button>
      </div>
      <div class="theme-point-panels">
        <div class="theme-point-panels__panel" data-tab-panel="kitten" data-tab-panel-state="active">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-1-1.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-1-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-1-2.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-1-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-1-3.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-1-3.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-1-4.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-1-4.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
        <div class="theme-point-panels__panel" data-tab-panel="cat">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-2-1.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-2-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-2-2.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-2-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-2-3.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-2-3.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-4/cat-slider-2-4.webp" type="image/webp">
                  <img src="/static/img/theme-4/cat-slider-2-4.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz'); sendEventYM('quiz4_click_btn')"
  >Закрепить знания</button>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue'
import { SliderManager } from '@/assets/js/script.js'
import analyticsTracking from '@/mixins/analyticsTracking.js'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'LessonCatsTopic4',
  mixins: [analyticsTracking],
  emits: ['goToQuiz'],
  setup() {
    let sliderManager = null

    onMounted(() => {
      sliderManager = new SliderManager()
      sliderManager.init()
    })

    onBeforeUnmount(() => {
      if (sliderManager) {
        sliderManager.destroy()
        sliderManager = null
      }
    })

    return {}
  }
}
</script>

<style scoped>
</style>
